import { defaultCountries as o } from "./default-countries.mjs";
import { DEFAULT_COUNTRY as e } from "./default-country.mjs";
const i = ".", r = {
  defaultCountry: e,
  initialCountry: e,
  value: "",
  prefix: "+",
  defaultMask: "............",
  // 12 chars
  charAfterDialCode: " ",
  historySaveDebounceMS: 200,
  allowMoreDigitsThanMaskAllows: !0,
  disableCountryGuess: !1,
  disableDialCodePrefill: !1,
  forceDialCode: !1,
  disableDialCodeAndPrefix: !1,
  countries: o,
  dontShowDialCodePrefillOnFocus: !1
};
export {
  i as MASK_CHAR,
  r as defaultPhoneConfig
};
